<template>
    <div>
        <!--User Details Collapse-->
        <v-collapse-group>
            <v-collapse-wrapper ref="user_details">
                <div :class="boxClass.box" class=" mb-3" id="user-details">
                    <h4 class="card-header" v-if="theme == 'bs4'">Your Details</h4>
                    <div :class="boxClass.boxHeader" v-else>
                        Your Details
                    </div>
                    <div v-collapse-content>
                        <div :class="[boxClass.boxBody]">
                            <div v-if="theme=='bs4'">
                                <div class="row">
                                    <div class="col">
                                        <input v-validate="'required'"
                                               data-vv-as="first name"
                                               placeholder="Your first name"
                                               data-vv-scope="user"
                                               class="form-control"
                                               name="first_name"
                                               type="text"
                                               :disabled="!enabled"
                                               @keyup.prevent="updateUser()"
                                               v-model="user.first_name"
                                               required
                                        >
                                        <div v-show="vErrors.has('user.first_name')"
                                             class="text-danger">
                                            {{ vErrors.first('user.first_name') }}
                                        </div>
                                    </div>
                                    <div class="col">
                                        <input v-validate="'required'"
                                               data-vv-as="last name"
                                               placeholder="Your last name"
                                               data-vv-scope="user"
                                               class="form-control"
                                               name="last_name"
                                               type="text"
                                               :disabled="!enabled"
                                               @keyup.prevent="updateUser()"
                                               v-model="user.last_name"
                                               required
                                        >
                                        <div v-show="vErrors.has('user.last_name')"
                                             class="text-danger">
                                            {{ vErrors.first('user.last_name') }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                <div class="form-group row">
                                    <label class="col-sm-2 col-lg-3 col-form-label text-left text-lg-right">First
                                        Name</label>
                                    <div class="col-sm-12 col-lg-6">
                                        <input v-validate="'required'"
                                               data-vv-as="first name"
                                               data-vv-scope="user"
                                               class="form-control"
                                               name="first_name"
                                               type="text"
                                               :disabled="!enabled"
                                               @keyup.prevent="updateUser()"
                                               v-model="user.first_name"
                                        >
                                        <div v-show="vErrors.has('user.first_name')"
                                             class="text-danger">
                                            {{ vErrors.first('user.first_name') }}
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-sm-2 col-lg-3 col-form-label text-left text-lg-right">Last
                                        Name</label>
                                    <div class="col-sm-12 col-lg-6">
                                        <input v-validate="'required'"
                                               data-vv-as="last name"
                                               data-vv-scope="user"
                                               class="form-control"
                                               name="last_name"
                                               type="text"
                                               :disabled="!enabled"
                                               @keyup.prevent="updateUser()"
                                               v-model="user.last_name"
                                        >
                                        <div v-show="vErrors.has('user.last_name')"
                                             class="text-danger">
                                            {{ vErrors.first('user.last_name') }}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row mt-2" v-for="(occasionAddition, index) in occasion.occasion_additions">
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <label
                                            class="form-label"
                                            :for="occasionAddition.addition.field_name"
                                        >{{ occasionAddition.addition.name }} <span
                                            v-if="occasionAddition.validation.required">*</span></label>
                                        <input
                                            class="form-control"
                                            :id="occasionAddition.addition.field_name"
                                            :name="occasionAddition.addition.field_name"
                                            data-vv-scope="user"
                                            v-model="additionalTransactionValues[occasionAddition.addition_id]"
                                            type="text"
                                            v-validate="occasionAddition.validation"
                                            :placeholder="occasionAddition.addition.name"
                                            v-if="occasionAddition.addition.data_type.form_builder_type === 'text'"
                                        >
                                        <div v-show="vErrors.has(`user.${occasionAddition.addition.field_name}`)"
                                             class="text-danger">
                                            {{ vErrors.first(`user.${occasionAddition.addition.field_name}`) }}
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </v-collapse-wrapper>
        </v-collapse-group>

        <!--Pre-paid box-->
        <div :class="boxClass.box" class="mb-2">
            <h4 class="card-header" v-if="theme == 'bs4'">Select Tickets</h4>
            <div :class="boxClass.boxHeader" v-else>
                Select Tickets
            </div>

            <div :class="[boxClass.boxBody, boxClass.padding]" class="d-none d-sm-block">
                <table class="table">
                    <tr>
                        <th>Name</th>
                        <th>Date</th>
                        <th>Price</th>
                        <th class="text-right">Ticket</th>
                    </tr>
                    <tr v-for="registrationCategory in registrationCategories">
                        <td class="align-middle"> {{ registrationCategory.name }}</td>
                        <td class="align-middle"> {{
                                registrationCategory.date | dateFormat(occasion.timezone,
                                    "DD/MM/YY HH:mm")
                            }}
                        </td>
                        <td class="align-middle"> {{
                                registrationCategory.current_price.amount |
                                    money(registrationCategory.current_price.currency)
                            }}
                        </td>
                        <td class="text-right">
                            <plus-minus-control
                                class="float-right"
                                style="display:inline-block"
                                v-model="tickets[registrationCategory.id]"
                                :disabled="!enabled"
                                :max="ParseInt(registrationCategory.pre_pay_setting.data.max_pre_pay_quantity)"
                                :min="getMinValueForPrepay(registrationCategory)"
                            ></plus-minus-control>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="5" class="text-right">
                            Total number of tickets: {{ totalNumOfTickets }}
                            Total Price: {{ totalPrice | money(occasion.currency) }}
                        </td>
                    </tr>
                    <tr v-if="bundleBooking !== null">
                        <td colspan="5">
                            <display-bundle-booking-benefits
                                :bundle-booking="bundleBooking"
                                :number-of-participants-selected="totalNumOfTickets"
                            ></display-bundle-booking-benefits>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
        <div v-if="theme == 'bs4'" :class="[boxClass.boxBody, boxClass.padding]" class="mb-4 d-block d-sm-none">
            <ul class="list-group text-center mb-2">
                <li class="list-group-item" v-for="registrationCategory in registrationCategories">
                    <h4>{{ registrationCategory.name }}</h4>
                    <p>{{
                            registrationCategory.date | dateFormat(occasion.timezone,
                                "DD/MM/YY HH:mm")
                        }}</p>
                    <p>{{
                            registrationCategory.current_price.amount |
                                money(registrationCategory.current_price.currency)
                        }}</p>
                    <p>
                        <status-badge :status="registrationCategory.human_status"></status-badge>
                    </p>
                    <p>
                        <plus-minus-control
                            style="display:inline-block"
                            v-model="tickets[registrationCategory.id]"
                            :disabled="!enabled"
                            :max="ParseInt(registrationCategory.pre_pay_setting.data.max_pre_pay_quantity)"
                            :min="ParseInt(registrationCategory.pre_pay_setting.data.min_pre_pay_quantity)"
                        ></plus-minus-control>
                    </p>
                </li>
            </ul>
            <div class="text-center">
                Total number of tickets: {{ totalNumOfTickets }}
                Total Price: {{ totalPrice | money(occasion.currency) }}
                <hr>
                <display-bundle-booking-benefits
                    v-if="bundleBooking !== null"
                    :bundle-booking="bundleBooking"
                    :number-of-participants-selected="totalNumOfTickets"
                ></display-bundle-booking-benefits>
            </div>
        </div>


        <!--Select Team-->
        <div>
            <div
                :class="boxClass.box"
                v-for="registrationCategory in registrationCategories"
                v-if="tickets[registrationCategory.id] > 0 && registrationCategory.allowed_team_entries">

                <h4 class="card-header" v-if="theme == 'bs4'">Setup team for {{ registrationCategory.name }}</h4>
                <div :class="boxClass.boxHeader" v-else>
                    Select Tickets
                </div>

                <div :class="boxClass.boxBody" class="text-center">
                    <p>{{
                            'team_picker_description' | mapField(occasion.field_mappings, 'If you want to setup a team, please select below.')
                        }}</p>
                    <team-picker-form
                        :field-mappings="occasion.field_mappings"
                        :opt-out-options="registrationCategory.opt_out_occasion_form_fields.filter(oooff => oooff.name.slice(0, 18).toLowerCase() == 'team_picker_option').map(oooff => oooff.name.slice(19, oooff.name.length))"
                        :registration-category-id="registrationCategory.id"
                        :show-validation-errors="showValidationErrors"
                        v-model="teams[registrationCategory.id]"
                        :team="registrationCategory.team"
                        :team-id-prop="registrationCategory.hasOwnProperty('team') && Boolean(registrationCategory.team) ? registrationCategory.team.id : null"
                        @validation="setValidated($event)"
                    ></team-picker-form>
                </div>
            </div>
        </div>

        <!--Donations-->
        <div v-if="charities.length" class="mt-2">
            <h4>Donate</h4>
            <donation-group
                :charities="charities"
                :single-address="true"
                :user-entity="upToDateUserEntity"
                :submittable="false"
                :theme="theme"
                v-model="donations"
                :disabled="!enabled"
            ></donation-group>
        </div>

        <!--Submit button-->
        <b-button variant="success" :disabled="!enabled || !totalNumOfTickets || submitting" @click="submit"
                  :block="true">
            <span v-if="!submitting">Continue</span>
            <span v-else>Submitting..</span>
        </b-button>
    </div>
</template>

<script>
import DonationGroup from "../../Donations/Form/Bulk.vue";
import StatusBadge from '../StatusBadge.vue'
import PlusMinusControl from '../../AAA_TO_REFACTOR/PlusMinsControl.vue'
import {dateFormat} from '../../Utility/filters/dates'
import {money} from '../../Utility/filters/money'
import {pick} from "lodash-es"
import axios from 'axios'
import TeamPickerForm from "../../Teams/Form/Picker";
import BFormInput from 'bootstrap-vue/es/components/form-input/form-input';
import {mapField} from "../../FieldMappings/filters/mapField";
import DisplayBundleBookingBenefits from "../../BundleBookings/DisplayBenefits.vue";
import ParseInt from "lodash-es/parseInt";

export default {
    name: "BulkParticipant",
    components: {
        BFormInput,
        DisplayBundleBookingBenefits,
        DonationGroup,
        PlusMinusControl,
        StatusBadge,
        TeamPickerForm,
    },
    filters: {
        money,
        dateFormat,
        mapField,
    },
    props: {
        occasion: {
            type: Object,
            required: true,
        },
        userEntity: { // TODO: extremely insecure, change ASAP (Ben did not write this...)
            type: [Object, Boolean],
            required: false,
        },
        theme: {
            type: String,
            default: 'bs4',
        },
        transaction: {
            type: Object,
            required: false,
            default: () => ({})
        },
        topUpBulkAction: {
            type: Boolean,
            required: false,
            default: false,
        }
    },
    data() {
        return {
            additionalTransactionValues: {},
            donations: this.transaction.donations, //TODO -  Map any donations from the transaction
            fields: ['name', 'date', 'price', 'ticket'],
            tickets: {},
            user: {
                id: '',
                first_name: '',
                last_name: '',
                confirmed: false
            },
            showValidationErrors: false,
            submitting: false,
            validationFields: {},
        }
    },

    created() {
        this.registrationCategories.forEach(({id}) => {
            this.$set(this.tickets, id, 0);
        });
        if (this.userEntity) {
            this.user = this.userEntity;
            this.user.confirmed = true;
        }
        //Pre-select any already selected tickets (editing)
        if (this.transaction.hasOwnProperty('participants') && this.transaction.participants.length > 0) {
            this.transaction.participants.map(p => p.registration_category_id).forEach((x) => {
                if (this.registrationCategories.find(registrationCategory => registrationCategory.id == x)) {
                    this.tickets[x] = (this.tickets[x] || 0) + 1;
                }
            });
        }
        //Generate any additional transaction values
        this.transaction.hasOwnProperty('additional_transaction_values') && this.transaction.additional_transaction_values.forEach((v, k) => {
            this.additionalTransactionValues[v.addition_id] = v.value;
        });
    },
    computed: {
        bundleBooking() {
            if (Object.prototype.hasOwnProperty.call(this.occasion, "bundle_bookings") && this.occasion.bundle_bookings.length > 0) {
                return this.occasion.bundle_bookings[0];
            } // true

            return null;
        },
        upToDateUserEntity() {
            return Object.assign({}, this.userEntity, this.user);
        },
        registrationCategories() {
            return this.occasion.registration_categories
                .map(registrationCategory => {
                    let
                        computedRegistrationCategory = pick(registrationCategory, [
                            'id',
                            'name',
                            'date',
                            'timezone',
                            'current_price.amount',
                            'current_price.currency',
                            'human_status',
                            'max_pre_pay_quantity',
                            'min_pre_pay_quantity',
                            'allowed_team_entries',
                            'opt_out_occasion_form_fields',
                            'pre_pay_setting',
                        ]),
                        participant = this.transaction.hasOwnProperty('participants') && this.transaction.participants.length
                            ? this.transaction.participants.find(participant => participant.registration_category_id == registrationCategory.id && participant.team_id)
                            : null
                    ;

                    computedRegistrationCategory.team = participant
                        ? participant.team
                        : null;

                    return computedRegistrationCategory;
                });
        },
        teams() {
            return Object.fromEntries(this.registrationCategories
                .map(registrationCategory => {
                    let teamId = registrationCategory.team
                        ? registrationCategory.team.id
                        : null;

                    return [registrationCategory.id, teamId];
                }));
        },
        totalPrice() {
            return Object.entries(this.tickets)
                .map(([key, val]) => this.registrationCategories.find(i => i.id == key).current_price.amount * val)
                .reduce((acc, i) => acc + i, 0)
        },
        totalNumOfTickets() {
            return Object.entries(this.tickets).reduce((acc, [key, val]) => acc + val, 0);
        },
        enabled() {
            return this.user.id;
        },
        boxClass() {
            if (this.theme == 'bs3') {
                return {
                    box: 'panel panel-default',
                    boxHeader: 'panel-heading',
                    boxBody: 'panel-body',
                    boxFooter: 'panel-footer',
                    padding: ''
                }
            } else if (this.theme == 'evt') {
                return {
                    box: 'box box-default',
                    boxHeader: 'box-header with-border',
                    boxBody: 'box-body',
                    boxFooter: 'box-footer',
                    padding: ''
                }
            } else {
                return {
                    box: 'card card-default',
                    boxHeader: 'card-header',
                    boxBody: 'card-body',
                    boxFooter: 'card-footer',
                    padding: 'px-0 py-0'
                }
            }
        },
        charities() {
            //Get a list of charity ID's
            let selectedRcIds = Object.keys(this.tickets).filter(key => this.tickets[key] > 0).map(x => +x);

            //Get a list of charity_id's to show
            let charityIdsToShow = this.occasion.registration_categories.filter(rc => selectedRcIds.includes(rc.id)).map(rc => rc.charity_ids_to_show).flat(2);

            //Get any charity ID's where a donation has been started
            // let inUseCharityIds = this.donations.filter(donation => donation.charity_id).map(donation => donation.charity_id);
            //
            // charityIdsToShow = charityIdsToShow.concat(inUseCharityIds);

            return this.occasion.charities.filter(charity => charityIdsToShow.includes(charity.id));
        }
    },
    methods: {
        ParseInt,
        setValidated(event) {
            this.validationFields[event.fieldName] = event.value;
        },
        submit() {
            if (!this.validate()) {
                this.showValidationErrors = true;
                return false;
            } else {
                this.showValidationErrors = false;
            }

            this.$validator.validateAll('user').then((result) => {
                this.submitting = true;

                if (result) {
                    let additional_transaction_values = Object.entries(this.additionalTransactionValues)
                        .map(([addition_id, value]) => Object.assign({}, {
                            addition_id,
                            value,
                            'transaction_id': this.transaction.id
                        }));

                    this.transaction.user_id = this.user.id;
                    let transaction = this.transaction;

                    axios
                        .post('/api/v0/participants/bulk', {
                            additional_transaction_values,
                            donations: this.donations,
                            occasion_id: this.occasion.id,
                            teams: this.teams,
                            tickets: this.tickets,
                            transaction,
                            user: this.user,
                        })
                        .then((response) => {
                            let status = response.data.status;
                            if (status == "error") {

                                let errors = response.data.data.errors;

                                //Inject errors to validator
                                errors.forEach((error) => {
                                    let keys = Object.keys(error);
                                    keys.forEach(key => {
                                        let innerError = error[key];
                                        let field = key;
                                        let msg = Object.values(innerError)[0];
                                        this.vErrors.add({
                                            field: field,
                                            msg: msg
                                        });
                                    })
                                });

                                this.submitting = false;
                            } else if (status == "success") {
                                //Redirect to basket
                                window.location = response.data.data.redirect
                            }
                        }).catch((response) => {
                        this.submitting = false;
                        alert('There was a problem saving your tickets.  Please contact support@eventrac.co.uk');
                    })
                } else {
                    this.submitting = false;
                }

            }).catch(response => {
                alert('hee')
            });
        },
        /**
         * Updates the user entity.  This happens after we ask them to confirm their details.  Performs an API call to update their details at a DB level
         */
        updateUser() {
            //Validate if we can save the user
            this.$validator.validateAll('user').then((result) => {
                if (result) {
                    this.user.saving = true;
                    this.saving = true;
                    axios.put('/api/internal/users/edit/' + this.user.id + '.json', {
                        first_name: this.user.first_name,
                        last_name: this.user.last_name,
                        dob: this.user.dob,
                    }).then((response) => {
                        this.user.confirmed = true;
                    }).catch((error) => {

                    });
                }
            });
        },
        validate() {
            return !Object.values(this.validationFields).filter(validated => !validated).length;
        },
        getMinValueForPrepay(registrationCategory) {
            if (this.topUpBulkAction) {
                return 1;
            }

            return parseInt(registrationCategory.pre_pay_setting.data.min_pre_pay_quantity);
        },
    },
}
</script>



// WEBPACK FOOTER //
// src/Assets/components/Participants/Form/Bulk.vue